export default "__VITE_ASSET__D3kUNqHL__"